(function () {
  const storyRoot = document.querySelector('.carbon-story');
  if (!storyRoot) return;

  const revealElements = storyRoot.querySelectorAll('[data-reveal]');

  if ('IntersectionObserver' in window && revealElements.length) {
    const revealObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      },
      { root: null, rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );

    revealElements.forEach((element) => revealObserver.observe(element));
  } else {
    revealElements.forEach((element) => element.classList.add('is-visible'));
  }

  const craftVideos = storyRoot.querySelectorAll('[data-craft-video]');

  const loadCraftVideo = (video) => {
    if (video.dataset.loaded === 'true') {
      return;
    }

    const source = video.querySelector('source[data-src]');

    if (source?.dataset.src) {
      source.src = source.dataset.src;
      video.load();
      video.dataset.loaded = 'true';
    }
  };

  const playCraftVideo = (video) => {
    const media = video.closest('.carbon-story__craft-media');
    loadCraftVideo(video);

    const playPromise = video.play();

    if (playPromise && typeof playPromise.then === 'function') {
      playPromise
        .then(() => {
          media?.classList.add('is-playing');
        })
        .catch(() => {
          media?.classList.remove('is-playing');
        });
    } else {
      media?.classList.add('is-playing');
    }
  };

  const pauseCraftVideo = (video) => {
    video.pause();
    video.closest('.carbon-story__craft-media')?.classList.remove('is-playing');
  };

  if (craftVideos.length && 'IntersectionObserver' in window) {
    const craftVideoObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;

          if (entry.isIntersecting) {
            playCraftVideo(video);
          } else {
            pauseCraftVideo(video);
          }
        });
      },
      { root: null, rootMargin: '0px', threshold: 0.35 }
    );

    craftVideos.forEach((video) => craftVideoObserver.observe(video));
  }

  const parallaxTargets = storyRoot.querySelectorAll('[data-parallax]');
  let ticking = false;

  const updateParallax = () => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    parallaxTargets.forEach((target) => {
      const strength = parseFloat(target.getAttribute('data-parallax')) || 0.1;
      const rect = target.getBoundingClientRect();
      const viewportHeight = window.innerHeight || 1;
      const progress = (rect.top + rect.height * 0.5 - viewportHeight * 0.5) / viewportHeight;
      const offset = Math.max(Math.min(progress * strength * 100, 24), -24);
      target.style.transform = `translate3d(0, ${offset}px, 0)`;
    });

    ticking = false;
  };

  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateParallax);
  };

  if (parallaxTargets.length) {
    window.addEventListener('scroll', onScroll, { passive: true });
    updateParallax();
  }
})();
